var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#FED241"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.7497 24.0833C35.7497 22.9327 36.6824 22 37.833 22C38.9836 22 39.9163 22.9327 39.9163 24.0833V39.9167C39.9163 41.0673 38.9836 42 37.833 42C36.6824 42 35.7497 41.0673 35.7497 39.9167V24.0833Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.083 24.0833C24.083 22.9327 25.0157 22 26.1663 22C27.3169 22 28.2497 22.9327 28.2497 24.0833V39.9167C28.2497 41.0673 27.3169 42 26.1663 42C25.0157 42 24.083 41.0673 24.083 39.9167V24.0833Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.962f359b5b5b7e4a5349423e40d651cd.svg";
export { ForwardRef as ReactComponent };